import type { StandardSvgProps } from "src/components/svg/StandardSvgProps";
import classNames from "classnames";
import svgStyles from "./SVGStyles.module.css";

//#region [Props]
type LeftArrowSvgProps = {
} & StandardSvgProps;
//#endregion

//#region [Component]
export default function LeftArrowSvg({ className }: LeftArrowSvgProps) {
	return <svg className={classNames(svgStyles.SDefaultSvg, className)} viewBox="0 0 11.67 19.799999">
		<path d="M 11.67,1.77 9.9,0 0,9.9 9.9,19.8 11.67,18.03 3.54,9.9 Z" />
	</svg>;
}
//#endregion

//#region [Styles]
//#endregion
